export default "__VITE_ASSET__cEgzbfEj__"